import Link from "next/link";
import { useEffect, useState } from "react";
import fetchHeaderFooterData from "@/hooks/fetchHeaderFooterData";

const Corporate = ({ customClass, click, listStyle, showCorporateDropdown, setMenuactive }) => {
  const [corporateMenu, setCorporateMenu] = useState(false);

  const { headerApiData } = fetchHeaderFooterData();
  // Safely access corporate_menu
  const corporateMenuItems = (headerApiData.corporate_menu && headerApiData.corporate_menu.length > 0)
    ? headerApiData.corporate_menu[0].sub_menus || []
    : [];

  const [winWidth, setWinWidth] = useState(null);

  const corporateMenuHandler = () => {
    if (winWidth < 1000) {
      setCorporateMenu((prevState) => !prevState);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setWinWidth(window.innerWidth);
    }

    const handleResize = () => {
      if (typeof window !== "undefined") {
        setWinWidth(window.innerWidth);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className={`group ${customClass}`}>
        <div
          className={`relative flex gap-x-2 text-base xl:text-[1vw] lg:gap-x-[.5vw] items-center after:w-2 after:h-2 after:lg:w-[.5vw] after:lg:h-[.5vw] after:border-r after:border-b after:border-solid after:rotate-45 after:translate-y-[-2px]`}
          onClick={corporateMenuHandler}
        >
          Corporate
        </div>
        {
          <ul
            className={`bg-black capitalize text-white lg:text-[0.938vw] hidden lg:block lg:w-[12vw] relative lg:absolute lg:opacity-0 lg:invisible lg:group-hover:visible lg:group-hover:block lg:group-hover:opacity-100 ease-in-out duration-500 mt-5 lg:mt-[0vw] ${listStyle} ${corporateMenuItems ? "block" : "hidden"
              }`}
          >
            {corporateMenuItems?.map((item, index) => (
              <li key={index} onClick={click} className="px-4 lg:px-0">
                <Link
                  href={`${item.slug || '#'}`}
                  className="block lg:hover:bg-light-black lg:py-[0.8vw] lg:px-[1vw]"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        }
        {corporateMenu &&
          <ul
            className={`bg-black capitalize text-white lg:text-[0.938vw] block lg:hidden lg:w-[12vw] relative lg:absolute lg:opacity-0 lg:invisible lg:group-hover:visible lg:group-hover:block lg:group-hover:opacity-100 ease-in-out duration-500 mt-5 lg:mt-[0vw] ${listStyle} ${corporateMenuItems ? "block" : "hidden"
              }`}
          >
            {corporateMenuItems?.map((item, index) => (
              <li key={index} onClick={() => {
                // click()
                setMenuactive(false)
              }} className="px-4 lg:px-0">
                <Link
                  href={`/${item.slug || '#'}`}
                  className="block lg:hover:bg-light-black lg:py-[0.8vw] lg:px-[1vw]"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        }
      </div>
    </>
  );
};

export default Corporate;
